<template>
  <section>
    <!-- <img @click.prevent src="../../assets/images/learning-card.png"/> -->
    <img @click.prevent src="../../assets/images/learning-card/1.png"/>

    <h3 v-if="bought">有效期 {{ format(startDate) }}-{{ format(endDate) }}</h3>
    <h3 v-else>有效期一年</h3>
  </section>
</template>

<script>
import { format_filter as formatFilter } from '../../lib/dateUtils'

export default {
  props: ['startDate', 'endDate', 'bought'],

  methods: {
    format: t => formatFilter(t)('YYYY.MM.DD')
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

$global-width: 750;

section {
  position: relative;
  display: inline-block;
  // width: 92%;

  img {
    height: 100%;
    width: 100%;
  }

  h3 {
    position: absolute;
    // bottom: rem(50);
    // left: rem(42);
    bottom: rem(95);
    left: rem(95);
    color: #fff;
    font-size: rem(26);
    font-weight: 400;
  }

  @media screen and (orientation: landscape) {
    h3 {
      bottom: rem(150);
    }
  }
}
</style>
